import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container",
  style: {"background-color":"#FAFAFA"}
}
const _hoisted_2 = { key: 1 }

import ProfileCard from "@/components/ProfileCard.vue";
// @ts-ignore - Vue SFC default export
import LoadingPage from "@/components/LoadingPage.vue";
// @ts-ignore - Vue SFC default export
import VideoPage from '@/components/VideosPage.vue';
// @ts-ignore - Vue SFC default export
import LinksPage from "@/components/LinksPage.vue";
import { ref, computed, watchEffect, watch } from "vue";
import { trackEvent } from "@/utils/analytics";
import { auth, contactDocument } from "@/lib/firebase";
import { signInAnonymously, UserCredential } from "firebase/auth";
import { where, query, getDocs, Query, DocumentData } from "firebase/firestore";
import type { QwikUCard } from '@/types';

type Props = {
  shareid?: string | null;
  // ... other props
};


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  props: {
    shareid: { default: null }
  },
  setup(__props: any) {


// @ts-ignore - Vue SFC default export
const props = __props;

// State
const userCredential = ref<UserCredential | null>(null);
const sharedIdDoc = ref<string | null>(null);
const mysmartcard = ref<QwikUCard | null>(null);

// Calculate isVip based on business logic
const isVip = computed(() => {
  const card = mysmartcard.value;
  if (!card) return false;

  // Check if vipDialna is not null and not empty
  if (card.vipDialna != null && card.vipDialna.trim() !== '') {
    return true;
  }

  // Check if IsVIP is true
  if (card.IsVIP) {
    const expirationDate = card._AppPurchase?.Expiration_Date;

    // If Expiration_Date is empty, isVip is true
    if (!expirationDate || expirationDate.trim() === '') {
      return true;
    }

    // If Expiration_Date is not empty, check if it's greater than today
    // Format: 2026-11-02T06:36:54Z (ISO 8601)
    try {
      const expiration = new Date(expirationDate);
      const now = new Date();

      // Check if expiration date is in the future
      return expiration > now;
    } catch (error) {
      console.error('Error parsing expiration date:', error);
      return false;
    }
  }

  return false;
});

// Separate authentication logic
const handleAuthentication = async (): Promise<UserCredential | null> => {
  try {
    if (!userCredential.value) {
      userCredential.value = await signInAnonymously(auth);
    }
    return userCredential.value;
  } catch (error) {
    console.error("Authentication failed:", error);
    return null;
  }
};

// Separate query creation logic
const createContactQuery = (shareId: string): Query<QwikUCard> | null => {
  if (!shareId) return null;
  return query(contactDocument, where("_AppShare.cardIdShare", "==", shareId));
};

// Watch for changes and fetch data
watchEffect(() => {
  (async () => {
    try {
      const credential = await handleAuthentication();

      if (!credential) {
        console.error("No valid credentials");
        return;
      }

      // Only update if shareid changed
      if (sharedIdDoc.value !== props.shareid) {
        sharedIdDoc.value = props.shareid;
        if (sharedIdDoc.value) {
          const q = createContactQuery(sharedIdDoc.value);
          if (q) {
            const querySnapshot = await getDocs(q);
            const firstDoc = querySnapshot.docs[0];
            if (firstDoc) {
              const data = firstDoc.data() as QwikUCard;
              data.id = firstDoc.id;
              mysmartcard.value = data;
            }
          }
        }
      }
    } catch (error) {
      console.error("Error in watch effect:", error);
    }
  })();
}, {
  flush: 'post'
});

// Analytics
watch(mysmartcard, (newCard) => {
  if (newCard?.id && isVip.value) {
    trackEvent(newCard.id, 'visit', {}, newCard.companyId);
  }
});







return (_ctx: any,_cache: any) => {
  return (mysmartcard.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(ProfileCard, {
          mysmartcard: mysmartcard.value,
          "is-vip": isVip.value
        }, null, 8, ["mysmartcard", "is-vip"]),
        _createVNode(VideoPage, { mysmartcard: mysmartcard.value }, null, 8, ["mysmartcard"]),
        _createVNode(LinksPage, { mysmartcard: mysmartcard.value }, null, 8, ["mysmartcard"]),
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-center text-xs text-white" }, "Version 1.0.0", -1))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(LoadingPage)
      ]))
}
}

})